import { render, staticRenderFns } from "./EventEdit.vue?vue&type=template&id=a609642e&scoped=true"
import script from "./EventEdit.vue?vue&type=script&lang=js"
export * from "./EventEdit.vue?vue&type=script&lang=js"
import style0 from "./EventEdit.vue?vue&type=style&index=0&id=a609642e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a609642e",
  null
  
)

export default component.exports